module.exports = __webpack_public_path__ + "static/media/status-aberto.0ce5ee0b.svg";